import { useTranslation } from 'react-i18next';

import { BlocksecImg } from '@/assets';
import { AUDIT_LINK } from '@/constants';

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="flex flex-col items-center justify-center w-full mt-16 mb-5 sm:mt-20">
      <div className="scale-[0.8] sm:scale-100 flex justify-center items-center text-white text-opacity-75">
        <a href={AUDIT_LINK} target="_blank" className="flex items-center justify-center">
          <p className="text-lg font-medium">{t('footer.auditedBy')}</p>
          <img src={BlocksecImg} />
        </a>
      </div>
      <div className="flex items-center justify-center py-6 text-sm text-white text-opacity-60">
        {t('footer.copyright', {
          date: new Date().getFullYear(),
        })}
      </div>
    </footer>
  );
}

export default Footer;
